import React from 'react';

export default function Audience() {
  return <h2>Audience View – Participate in a quiz via link or QR code</h2>;
}

